import type { Freshness } from "./contracts";

export const LIVE_AFTER_MS = 45_000;
export const DELAYED_AFTER_MS = 120_000;
export const VESSEL_RETENTION_MS = 6 * 60_000;

export function freshnessAt(observedAtMs: number | null, nowMs: number): Freshness {
  if (observedAtMs === null || !Number.isFinite(observedAtMs) || observedAtMs > nowMs) return "unknown";
  const age = nowMs - observedAtMs;
  if (age <= LIVE_AFTER_MS) return "live";
  if (age <= DELAYED_AFTER_MS) return "delayed";
  return "stale";
}
